import React, { useCallback } from 'react';
import { Field, useFormikContext } from 'formik';
import _ from 'lodash';
import { Country } from '@tradingblock/types';
import { TextboxField, SelectDropdownField } from './';
import { FormGroup } from '../../basic';
const formatedValue = (value) => {
    return value
        ? value
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.substring(1))
            .join(' ')
        : '';
};
// Function to get USPS response from storage
const getUspsResponseFromStorage = (prefix) => {
    const uspsResponseFromStorage = sessionStorage.getItem(`${prefix}.uspsResponse`);
    return uspsResponseFromStorage && uspsResponseFromStorage !== 'undefined' ? uspsResponseFromStorage : null;
};
export const AddressField = ({ id, labelPrefix, countryProps, addr1Help, stateProps, field, }) => {
    const { value } = field;
    const country = _.get(value, `${id}.country`);
    const uspsResponse = getUspsResponseFromStorage(id);
    const context = useFormikContext();
    let uspsResponseValues, city, state, zip5, uspsAddress1, uspsAddress2;
    if (uspsResponse) {
        uspsResponseValues = JSON.parse(uspsResponse);
        city = formatedValue(uspsResponseValues.city);
        state = uspsResponseValues.state;
        zip5 = formatedValue(uspsResponseValues.zip5);
        uspsAddress1 = formatedValue(uspsResponseValues.uspsAddress1);
        uspsAddress2 = formatedValue(uspsResponseValues.uspsAddress2);
    }
    const getTextboxFieldProps = useCallback((field) => {
        const fieldProps = {
            component: TextboxField,
            id: `${id}.${field}`,
            defaultLabelId: `address.${field}`,
        };
        if (field === 'state') {
            fieldProps.defaultLabelId = `address.province`;
        }
        if (labelPrefix) {
            return Object.assign({}, fieldProps, { labelPrefix });
        }
        return fieldProps;
    }, [id, labelPrefix]);
    const showUseProvidedButton = () => {
        return (context.errors &&
            ((uspsAddress1 && context.errors[`${id}.address1`]) ||
                (uspsAddress2 && context.errors[`${id}.address2`]) ||
                (city && context.errors[`${id}.city`]) ||
                (state && context.errors[`${id}.state`]) ||
                (zip5 && context.errors[`${id}.postalCode`])));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({ component: SelectDropdownField, id: `${id}.country` }, countryProps, { autoComplete: `${id}.country` }))),
        React.createElement(FormGroup, { help: addr1Help },
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('address1')))),
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('address2')))),
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('city')))),
        React.createElement(FormGroup, null,
            (country === Country.UnitedStatesOfAmerica || country === '') && (React.createElement(React.Fragment, null,
                React.createElement(Field, Object.assign({ component: SelectDropdownField, id: `${id}.state` }, stateProps, { autoComplete: 'HEYOOOO' })))),
            country !== Country.UnitedStatesOfAmerica && country !== '' && (React.createElement(React.Fragment, null,
                React.createElement(Field, Object.assign({}, getTextboxFieldProps('state')))))),
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('postalCode')))),
        showUseProvidedButton() && (React.createElement(FormGroup, null,
            React.createElement("button", { className: "btn btn-block btn-outline-warning", onClick: e => {
                    e.preventDefault();
                    const updatedValues = _.cloneDeep(context.values);
                    // Create a helper function to safely set nested values
                    const setNestedValue = (path, value) => {
                        if (context.errors[path]) {
                            _.set(updatedValues, path, value);
                        }
                    };
                    // Use the full path with the id to set values
                    setNestedValue(`${id}.address1`, uspsAddress1);
                    setNestedValue(`${id}.address2`, uspsAddress2);
                    setNestedValue(`${id}.city`, city);
                    setNestedValue(`${id}.state`, state);
                    setNestedValue(`${id}.postalCode`, zip5);
                    // Update Formik's form values
                    context.setValues(updatedValues);
                    context.validateForm(updatedValues);
                } }, "Use USPS provided address")))));
};
//# sourceMappingURL=Address.js.map